<template>
  <button
    type="button"
    class="btn btn-seconadry close-button"
    @click="$emit('close')"
  >
    {{ label || "X" }}
  </button>
</template>
<style scoped>
.close-button {
  border: none;
  background: inherit;
  color: inherit;
  padding: 3px;
  font-size: 0.7rem;
  font-weight: bold;
}
.close-button:hover {
  color: initial;
  background-color: initial;
}
</style>
<script>
export default {
  props: ["label"],
  emits: ["close"],
};
</script>
